/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Fri May 06 2022
*  File : functions.ts
*******************************************/

import { Logger } from "@ciaopeople/cp-shatsu/Logging";

/**
 * Verifica se è disponibile il local storage
 * @returns true se è disponibile
 */
export function isLocalStorageAvailable(logger: Logger|Console = console): boolean {
    try {
        window.localStorage.setItem("check_item", "a");
        window.localStorage.getItem("check_item");
        window.localStorage.removeItem("check_item");
        return true;
    }
    catch(e) {
        logger.debug("LocalStorage is unavailable", e);
        return false;
    }
}
